import Vue from 'vue'
import axios from 'axios';
import qs from 'qs';

import saveAs from 'file-saver';

// import {Locales} from '../libs/trans';
//TODO where there is store.dispacth it should be replaced with commit from vue (dispatch is a leftover from when it was done on react but the same principle applies just set an error object)

import store from "../store";

import miniToastr from 'mini-toastr';

import {minitstr_config} from '@/constants';

miniToastr.init(minitstr_config);

import {
    HTTP_INTERNAL_ERROR,
    HTTP_NOT_ACCEPTABLE, HTTP_NOT_FOUND,
    HTTP_UNAUTHORIZED,
    HTTP_ENTITY_TOO_LARGE
} from "../constants";

class Http {
    constructor() {
        axios.defaults.headers.patch['Content-Type'] = 'application/x-www-form-urlencoded';
        axios.interceptors.request.use((request) => {
            if (request.data && request.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
                request.data = qs.stringify(request.data);
            }
            return request;
        });
        this._axios = axios.create({});
        this._url = process.env.API_URL;
        this._apiMethod = false;
        this._response = false;
        this._error = false;
    }

    _validate() {
        if (!this._apiMethod) {
            throw new Error('Method was not specified.');
        }

        store.commit('SET_AJAX_IN_PROGRESS', true);
    }

    route(apiMethod) {
        this._apiMethod = apiMethod;
        return this;
    }

    static _getAuthConfig() {
        let axiosConfig = {};

        const jwt = sessionStorage.getItem('jwt');

        if (jwt) {
            axiosConfig = Object.assign({}, {
                headers: {'Authorization': 'Bearer ' + jwt}
            });
        }

        return axiosConfig;
    }

    build() {
        let response = this._response && this._response.data ? {...this._response.data} : false;
        this._response = false;

        let isError = false;
        let errorMessage = {};
        let data = false;
        let pagination = false;
        let other = {};

        store.commit('SET_AJAX_IN_PROGRESS', false);

        if (response) {
            if (response.responseType && response.responseType === 'success') {

                data = response.data.result;
                pagination = response.data.pagination !== null ? response.data.pagination : false;
                other = response.data.other !== null ? response.data.other : {};

                if (response.force_reload == 1) {
                    store.dispatch('getUser');
                }
            } else {
                isError = true;
                if (typeof response.errorMessage === 'object') {
                    for (let error in response.errorMessage) {
                        if (response.errorMessage.hasOwnProperty(error)) {
                            if (Array.isArray(response.errorMessage[error])) {
                                //errorMessage = {...errorMessage, [error]: Vue.i18n.translate(response.errorMessage[error][0])};
                                errorMessage = {...errorMessage, [error]: response.errorMessage[error][0]};
                            } else {
                                //errorMessage = {...errorMessage, [error]: Vue.i18n.translate(response.errorMessage[error])};
                                errorMessage = {...errorMessage, [error]: response.errorMessage[error]};
                            }
                        }
                    }
                } else {

                    //errorMessage = {error: Vue.i18n.translate(response.errorMessage)};
                    errorMessage = {error: response.errorMessage};

                    if (response.errorMessage === 'errors.rememberToken.invalid') {
                        localStorage.removeItem('rememberToken');
                        window.location.reload();
                    }

                    if (response.errorMessage === 'errors.token') {
                        sessionStorage.removeItem('jwt');
                        window.location.reload();
                    }

                    if (response.errorMessage === 'errors.error') {
                        // store.dispatch(setError(errorMessage.error));
                    }

                }
            }
        } else {
            let error = Vue.i18n.translate('misc.api');
            isError = true;
            errorMessage = {error};
            // store.dispatch(setError(error));
        }

        return {
            isError,
            errorMessage,
            data,
            pagination,
            other
        };
    }

    buildError(status) {
        store.commit('SET_AJAX_IN_PROGRESS', false);

        let errorData = this._error ? {...this._error} : false;
        this._error = false;

        let isError = false;
        let errorMessage = {};
        let data = false;
        let pagination = false;
        let isNotFound = false;

        if (errorData) {
            isError = true;
            if (typeof errorData.errorMessage === 'object') {
                for (let error in errorData.errorMessage) {
                    if (errorData.errorMessage.hasOwnProperty(error)) {
                        if (Array.isArray(errorData.errorMessage[error])) {
                            //errorMessage = {...errorMessage, [error]: Vue.i18n.translate(errorData.errorMessage[error][0])};
                            errorMessage = {...errorMessage, [error]: errorData.errorMessage[error][0]};
                        } else {
                            //errorMessage = {...errorMessage, [error]: Vue.i18n.translate(errorData.errorMessage[error])};
                            errorMessage = {...errorMessage, [error]: errorData.errorMessage[error]};
                        }
                    }
                }
            } else {
                if (status === HTTP_NOT_ACCEPTABLE && errorData.errorMessage === 'errors.rememberToken.invalid') {
                    localStorage.removeItem('rememberToken');
                    window.location.reload();
                }

                if (status === HTTP_UNAUTHORIZED) {
                    sessionStorage.removeItem('jwt');
                    store.commit('forceLogout');

                    window.location.reload();
                }

                errorMessage = {error: errorData.errorMessage};
                //errorMessage = {error: Vue.i18n.translate(errorData.errorMessage)};

                if (status === HTTP_INTERNAL_ERROR) {
                    let error = Vue.i18n.translate('misc.api');
                    //commit('forceLogout');
                    // store.dispatch(setError(error));
                }

                if (status === HTTP_NOT_FOUND) {
                    isNotFound = true;
                }
            }
        }

        return {
            isError,
            errorMessage,
            data,
            pagination,
            isNotFound
        };
    }

    async get(options = {}) {
        this._validate();

        let url = `${this._url}/${this._apiMethod}`;
        this._apiMethod = false;

        let authConfig = Http._getAuthConfig();

        try {
            this._response = await this._axios.get(url, {
                params: {
                    ...options,
                    language: localStorage.getItem('lang') || process.env.DEFAULT_LANG
                },
                ...authConfig
            });
        } catch (e) {
            this._error = e.response.data;

            return this.buildError(e.response.status);
        }

        return this.build();
    }

    async post(data = {}) {
        this._validate();

        let url = `${this._url}/${this._apiMethod}`;
        this._apiMethod = false;

        let authConfig = Http._getAuthConfig();

        if (data instanceof FormData) {
            data.append('language', localStorage.getItem('lang') || process.env.DEFAULT_LANG);
        } else {
            data.language = localStorage.getItem('lang') || process.env.DEFAULT_LANG;
        }

        try {
            this._response = await this._axios.post(url, data, authConfig);
        } catch (e) {
            if(typeof e.response != 'undefined') {
                this._error = e.response.data;
                return this.buildError(e.response.status);
            } else {
            }
            this._error = {'errorMessage': 'Entity too large'};

            return this.buildError(HTTP_ENTITY_TOO_LARGE);
        }

        return this.build();
    }

    async delete(data = {}) {
        this._validate();

        let url = `${this._url}/${this._apiMethod}`;
        this._apiMethod = false;

        let authConfig = Http._getAuthConfig();

        try {
            this._response = await this._axios.delete(url, {...authConfig, params: {...data}});
        } catch (e) {
            this._error = e.response.data;

            return this.buildError(e.response.status);
        }

        return this.build();
    }

    async put(data = {}) {
        this._validate();

        let url = `${this._url}/${this._apiMethod}`;
        this._apiMethod = false;

        let authConfig = Http._getAuthConfig();

        try {
            this._response = await this._axios.put(url, {
                ...data,
                language: localStorage.getItem('lang') || process.env.DEFAULT_LANG
            }, authConfig);
        } catch (e) {
            this._error = e.response.data;

            return this.buildError(e.response.status);
        }

        return this.build();
    }

    async patch(data = {}) {
        this._validate();

        let url = `${this._url}/${this._apiMethod}`;
        this._apiMethod = false;

        let authConfig = Http._getAuthConfig();

        try {
            this._response = await this._axios.patch(url, {
                ...data,
                language: localStorage.getItem('lang') || process.env.DEFAULT_LANG
            }, authConfig);
        } catch (e) {
            this._error = e.response.data;

            return this.buildError(e.response.status);
        }

        return this.build();
    }

    async importExcel(data = {}) {
        this._validate();

        let url = `${this._url}/${this._apiMethod}`;
        this._apiMethod = false;

        let authConfig = Http._getAuthConfig();

        if (data instanceof FormData) {
            data.append('language', localStorage.getItem('lang') || process.env.DEFAULT_LANG);
        } else {
            data.language = localStorage.getItem('lang') || process.env.DEFAULT_LANG;
        }

        try {
            this._response = await this._axios.post(url, data, authConfig);
        } catch (e) {
            this._error = e.response.data;
            if (typeof this._error.errorMessage != 'undefined' && this._error.errorMessage != 'errors.error_import') {
                miniToastr.error(Vue.i18n.translate('errors.error_import'), Vue.i18n.translate('messages.error'), 5000);
            }

            return this.buildError(e.response.status);
        }

        return this.build();
    }

    async exportExcel(options = {}, fileName) {
        this._validate();

        let url = `${this._url}/${this._apiMethod}`;
        this._apiMethod = false;

        let authConfig = Http._getAuthConfig();

        try {
            miniToastr.info(Vue.i18n.translate('messages.exporting'), Vue.i18n.translate('messages.info'), 3500);
            this._response = await this._axios.get(url, {
                params: {
                    ...options,
                    language: localStorage.getItem('lang') || process.env.DEFAULT_LANG
                },
                ...authConfig, responseType: 'arraybuffer'
            });
        } catch (e) {
            miniToastr.error(Vue.i18n.translate('messages.can_not_export'), Vue.i18n.translate('messages.error'), 5000);
            this._error = e.response.data;

            return this.buildError(e.response.status);
        }

        let response = this._response ? {...this._response} : false;
        this._response = false;

        store.commit('SET_AJAX_IN_PROGRESS', false);

        if (response) {
            saveAs(new Blob([response.data], {type: response.headers['content-type']}), fileName);
        }
    }

    async exportCsv(options = {}, fileName) {
        this._validate();

        let url = `${this._url}/${this._apiMethod}`;
        this._apiMethod = false;

        let authConfig = Http._getAuthConfig();

        try {
            this._response = await this._axios.get(url, {
                params: {
                    ...options,
                    language: localStorage.getItem('lang') || process.env.DEFAULT_LANG
                },
                ...authConfig, responseType: 'arraybuffer'
            });
        } catch (e) {
            this._error = e.response.data;

            return this.buildError(e.response.status);
        }

        let response = this._response ? {...this._response} : false;
        this._response = false;

        store.commit('SET_AJAX_IN_PROGRESS', false);

        if (response) {
            saveAs(new Blob([response.data], {type: response.headers['content-type']}), fileName);
        }
    }

    async generatePdf(data = {}, fileName) {
        this._validate();

        let url = `${this._url}/${this._apiMethod}`;
        this._apiMethod = false;

        let authConfig = Http._getAuthConfig();

        if (data instanceof FormData) {
            data.append('language', localStorage.getItem('lang') || process.env.DEFAULT_LANG);
        } else {
            data.language = localStorage.getItem('lang') || process.env.DEFAULT_LANG;
        }

        try {
            this._response = await this._axios.post(url, data, {...authConfig, responseType: 'arraybuffer'});
        } catch (e) {
            this._error = e.response.data;

            return this.buildError(e.response.status);
        }

        let response = this._response ? {...this._response} : false;
        this._response = false;

        store.commit('SET_AJAX_IN_PROGRESS', false);

        if (response) {
            saveAs(new Blob([response.data], {type: response.headers['content-type']}), fileName);
        }
    }

    async downloadPdf(options = {}, filename) {
        this._validate();

        let url = `${this._url}/${this._apiMethod}`;
        this._apiMethod = false;

        let authConfig = Http._getAuthConfig();

        try {
            this._response = await this._axios.get(url, {
                params: {
                    ...options,
                    language: localStorage.getItem('lang') || process.env.DEFAULT_LANG
                },
                ...authConfig, responseType: 'arraybuffer'
            });
        } catch (e) {
            this._error = e.response.data;
            return this.buildError(e.response.status);
        }

        let response = this._response ? {...this._response} : false;
        this._response = false;

        store.commit('SET_AJAX_IN_PROGRESS', false);

        if (response) {
            saveAs(new Blob([response.data], {type: response.headers['content-type']}), filename);
        }
    }

    async viewImage(options = {}, filename) {
        this._validate();

        let url = `${this._url}/${this._apiMethod}`;
        this._apiMethod = false;

        let authConfig = Http._getAuthConfig();

        try {
            this._response = await this._axios.get(url, {
                params: {
                    ...options,
                    language: localStorage.getItem('lang') || process.env.DEFAULT_LANG
                },
                ...authConfig, responseType: 'arraybuffer'
            });
        } catch (e) {
            this._error = e.response.data;

            return this.buildError(e.response.status);
        }

        let response = this._response ? {...this._response} : false;
        this._response = false;

        store.commit('SET_AJAX_IN_PROGRESS', false);

        if (response) {
            return 'data:image/jpeg;base64,' + btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
        }
    }

}

export default new Http();



// WEBPACK FOOTER //
// ./src/libs/http.js